/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-direction:column;height:100%}.app-container[_ngcontent-%COMP%]{width:100%;height:calc(100% - 66px);margin-top:66px;position:relative;overflow-y:hidden;padding:0}app-header[_ngcontent-%COMP%]{position:relative}.custom-progress-bar[_ngcontent-%COMP%]{position:absolute!important;z-index:14;left:0;bottom:0}.app-loading-container[_ngcontent-%COMP%]{z-index:9;position:absolute!important;background-color:rgba(4,12,21,.13)!important;display:none}"];
export { styles as styles };
